module.exports = __webpack_public_path__ + "static/media/arrow-strong-right.03420b88.svg";